/* Astory Media hard-coded product image zoom (replaces broken paid zoom app).
   Works against the existing gallery markup untouched: #content .gallery-control > .img_thumb > .engoj-nav-item > img
   Desktop: hover magnifier. Touch: tap toggles the same zoomed pane, drag/tap-move to pan, tap again to close.
   Slide arrows/dots stay usable while zoomed, and the zoomed image refreshes to match whichever photo is showing.
   Also owns the one-time slick carousel rebuild after load (the theme's own unslick/reinit "slider patch"
   is disabled in theme.liquid now that this replaces it), with a short retry loop as a backstop, since a
   single untimed reinit could otherwise leave slides sized/positioned to a stale container width. */
(function(){
  if(window.__ppZoomInit) return;
  window.__ppZoomInit = true;

  var ZOOM_FACTOR = 2.2; // magnification level, both hover and tap

  function ready(fn){
    if(document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function(){
    document.querySelectorAll('#content .gallery-control').forEach(setupStage);
  });

  // ---- Own the one-time slick rebuild (replaces the theme's original unslick/reinit patch, ----
  // ---- which is now neutralised in theme.liquid) so there's only ever a single reinit, run ----
  // ---- once the gallery is actually laid out correctly, with a short retry loop as a backstop. ----
  var slickFixDone = false;
  var slickFixAttempts = 0;

  function rebuildSlick(el, currentSlide){
    try {
      el.slick('unslick');
      el.slick({slidesToShow: 1, slidesToScroll: 1, arrows: true, dots: true, adaptiveHeight: true, initialSlide: currentSlide || 0});
    } catch(e) {}
  }

  function fixSlickWidths(){
    if(!window.jQuery || slickFixDone) return;
    var galleries = jQuery('.js_prod_detail');
    if(!galleries.length) return;

    var allGood = true;
    galleries.each(function(){
      var el = jQuery(this);
      var wrapWidth = el.width();
      if(!wrapWidth) { allGood = false; return; }

      if(!el.hasClass('slick-initialized')){
        rebuildSlick(el, 0);
        allGood = false;
        return;
      }

      // Check both the slide width AND the clipping .slick-list width: slick can leave the
      // .slick-list container itself sized to a stale width even when individual slides look right
      // (e.g. if something else on the page reflows mid-init, such as the animated promo ticker).
      var firstSlide = el.find('.slick-slide').get(0);
      var list = el.find('.slick-list').get(0);
      if(!firstSlide || !list) { allGood = false; return; }
      var slideWidth = firstSlide.getBoundingClientRect().width;
      var listWidth = list.getBoundingClientRect().width;
      if(Math.abs(slideWidth - wrapWidth) >= 2 || Math.abs(listWidth - wrapWidth) >= 2){
        var currentSlide = 0;
        try { currentSlide = el.slick('slickCurrentSlide'); } catch(e) {}
        rebuildSlick(el, currentSlide);
        allGood = false;
      }
    });

    slickFixAttempts++;
    if(allGood){
      slickFixDone = true;
    } else if(slickFixAttempts < 14){
      setTimeout(fixSlickWidths, 400);
    }
  }

  window.addEventListener('load', function(){
    setTimeout(fixSlickWidths, 350);
  }, {once: true});
  window.addEventListener('resize', function(){
    slickFixDone = false;
    slickFixAttempts = 0;
    clearTimeout(window.__ppSlickResizeT);
    window.__ppSlickResizeT = setTimeout(fixSlickWidths, 200);
  });

  function activeImg(stage){
    return stage.querySelector('.img_thumb .slick-current img') || stage.querySelector('.img_thumb img');
  }

  function refreshBg(pane, stage){
    var img = activeImg(stage);
    if(!img) return;
    var url = 'url("' + img.src + '")';
    if(pane.style.backgroundImage !== url) pane.style.backgroundImage = url;
  }

  function setPanePosition(pane, stage, clientX, clientY){
    var rect = stage.getBoundingClientRect();
    var xPct = ((clientX - rect.left) / rect.width) * 100;
    var yPct = ((clientY - rect.top) / rect.height) * 100;
    xPct = Math.max(0, Math.min(100, xPct));
    yPct = Math.max(0, Math.min(100, yPct));
    pane.style.backgroundPosition = xPct + '% ' + yPct + '%';
  }

  function isSlideControl(target){
    return target.closest && target.closest('.slick-arrow, .slick-dots');
  }

  function setupStage(stage){
    if(stage.dataset.ppZoomReady) return;
    stage.dataset.ppZoomReady = '1';

    var pane = document.createElement('div');
    pane.className = 'pp-hoverzoom';
    pane.setAttribute('aria-hidden', 'true');
    stage.appendChild(pane);

    var hoverCapable = window.matchMedia('(hover: hover) and (pointer: fine)');

    // ---- Desktop hover ----
    stage.addEventListener('mouseenter', function(){
      if(!hoverCapable.matches || window.innerWidth < 992) return;
      var img = activeImg(stage);
      if(!img) return;
      pane.style.backgroundImage = 'url("' + img.src + '")';
      pane.style.backgroundSize = (ZOOM_FACTOR * 100) + '%';
      stage.classList.add('pp-hover-active');
    });
    stage.addEventListener('mousemove', function(e){
      if(!stage.classList.contains('pp-hover-active')) return;
      refreshBg(pane, stage);
      setPanePosition(pane, stage, e.clientX, e.clientY);
    });
    stage.addEventListener('mouseleave', function(){
      stage.classList.remove('pp-hover-active');
    });

    // ---- Keep the zoomed image in sync when the slide changes via arrows/dots ----
    stage.addEventListener('click', function(){
      setTimeout(function(){
        if(stage.classList.contains('pp-hover-active') || stage.classList.contains('pp-touch-active')){
          pane.style.backgroundSize = (ZOOM_FACTOR * 100) + '%';
          refreshBg(pane, stage);
        }
      }, 60);
    }, true);

    // ---- Touch: tap to toggle, drag to pan while open. Tapping an arrow/dot changes slide instead of closing. ----
    var touchActive = false;

    stage.addEventListener('touchstart', function(e){
      if(!e.touches || !e.touches.length) return;
      if(isSlideControl(e.target)) return; // let slick handle the tap; the click listener above refreshes the zoomed image after

      var touch = e.touches[0];

      if(touchActive){
        // second tap: close
        touchActive = false;
        stage.classList.remove('pp-touch-active');
        return;
      }

      var img = activeImg(stage);
      if(!img) return;
      pane.style.backgroundImage = 'url("' + img.src + '")';
      pane.style.backgroundSize = (ZOOM_FACTOR * 100) + '%';
      setPanePosition(pane, stage, touch.clientX, touch.clientY);
      touchActive = true;
      stage.classList.add('pp-touch-active');
    }, {passive: true});

    stage.addEventListener('touchmove', function(e){
      if(!touchActive || !e.touches || !e.touches.length) return;
      if(isSlideControl(e.target)) return;
      var touch = e.touches[0];
      refreshBg(pane, stage);
      setPanePosition(pane, stage, touch.clientX, touch.clientY);
    }, {passive: true});
  }
})();
